<div class="drawer-container p-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h3 class="mb-0">Technical Details</h3>
    <button mat-icon-button (click)="close()">
      <i class="material-icons">close</i>
    </button>
  </div>

  <div class="card mb-4">
    <div class="card-body">
      <h5 class="card-title text-primary">URL Overview</h5>
      <p class="text-muted small mb-1">{{ audit.url }}</p>
      <div class="row mt-3">
        <div class="col-6">
          <p class="mb-1"><strong>Status:</strong> {{ audit.indexability?.status || 'N/A' }}</p>
          <p class="mb-1"><strong>Canonical:</strong> {{ audit.indexability?.canonical || 'None' }}</p>
          <p class="mb-1"><strong>Robots:</strong> {{ audit.indexability?.metaRobots || 'None' }}</p>
        </div>
        <div class="col-6">
          <p class="mb-1"><strong>Schema:</strong> {{ audit.technical?.schemaDetected ? 'Yes' : 'No' }}</p>
          <p class="mb-1"><strong>Types:</strong> {{ audit.technical?.schemaTypes?.join(', ') || 'None' }}</p>
          <p class="mb-1"><strong>Score:</strong> <span class="font-weight-bold">{{ audit.healthScore }}</span></p>
        </div>
      </div>
    </div>
  </div>

  <!-- Issues -->
  <div class="section mb-4">
    <h5 class="text-danger font-weight-bold mb-3">Detected Issues</h5>
    <div *ngIf="audit.issuesDetected?.length > 0; else noIssues">
      <div *ngFor="let issue of audit.issuesDetected" class="alert d-flex align-items-start mb-2" [ngClass]="issue.priority === 'P0' ? 'alert-danger' : issue.priority === 'P1' ? 'alert-warning' : 'alert-info'">
        <span class="badge mr-2" [ngClass]="getPriorityBadgeClass(issue.priority)">{{ issue.priority }}</span>
        <div>
          <p class="mb-1"><strong>{{ issue.problem }}</strong></p>
          <p class="mb-0 small">{{ issue.recommendation }}</p>
        </div>
      </div>
    </div>
    <ng-template #noIssues>
      <div class="alert alert-success">No technical issues detected in this audit.</div>
    </ng-template>
  </div>

  <!-- History -->
  <div class="section mt-4">
    <h5 class="text-primary font-weight-bold mb-3">Health History</h5>
    <div class="table-responsive">
      <table class="table table-sm">
        <thead>
          <th>Date</th>
          <th class="text-center">Score</th>
          <th class="text-center">Issues</th>
        </thead>
        <tbody>
          <tr *ngFor="let entry of history">
            <td>{{ entry.checkedAt | date:'short' }}</td>
            <td class="text-center font-weight-bold">{{ entry.healthScore }}</td>
            <td class="text-center">{{ entry.issuesDetected?.length || 0 }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
